module.exports = __webpack_public_path__ + "static/img/tzzqq3.0cebd90.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bc/tzzqq3.png
// module id = vrBE
// module chunks = 0